import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import moment from 'moment';

import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

import TSTable from '@ts-core/components/Table/TSTable';
import ConfirmButton from '@ts-core/components/ConfirmButton';

const CourseStudentsTable = (props) => {
  const intl = useIntl();

  const { loading, students, onRemoveStudent, onSelectStudent, onFilterStudents } = props;

  const handleRemoveStudent = useCallback(
    (student) => () => {
      onRemoveStudent(student);
    },
    [onRemoveStudent]
  );

  const getActionsCell = useCallback(
    (_value, _, student) => {
      if (!onRemoveStudent) return null;
      return (
        <div>
          <ConfirmButton
            onConfirm={handleRemoveStudent(student)}
            alertMessage={intl.formatMessage(
              {
                id: 'dialog.confirmRemoveStudentFromCourse.title',
              },
              { student: student.name }
            )}
            renderButton={({ onClick }) => (
              <IconButton onClick={onClick} size="large">
                <DeleteIcon />
              </IconButton>
            )}
          />
        </div>
      );
    },
    [handleRemoveStudent, intl, onRemoveStudent]
  );

  const columns = useMemo(
    () => [
      {
        Header: intl.formatMessage({ id: 'studentsTable.column.name' }),
        value: intl.formatMessage({ id: 'studentsTable.column.name' }),
        accessor: 'name',
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'studentsTable.column.email' }),
        value: intl.formatMessage({ id: 'studentsTable.column.email' }),
        accessor: 'email',
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'studentsTable.column.personalId' }),
        value: intl.formatMessage({ id: 'studentsTable.column.personalId' }),
        accessor: 'personalId',
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'studentsTable.column.group' }),
        value: intl.formatMessage({ id: 'studentsTable.column.group' }),
        accessor: 'group.name',
        id: 'group.name',
        sortable: true,
        filterable: true,
      },
      {
        Header: intl.formatMessage({ id: 'studentsTable.column.addedAt' }),
        value: intl.formatMessage({ id: 'studentsTable.column.addedAt' }),
        accessor: 'addedAt',
        sortable: true,
        valueTransformer: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
      },
      {
        Header: '',
        accessor: '_id',
        valueTransformer: getActionsCell,
      },
    ],
    [intl, getActionsCell]
  );

  return (
    <TSTable
      loading={loading}
      data={students}
      columns={columns}
      onSearch={onFilterStudents}
      allowDownloadAsXLSX
      xlsxFileName="alumnos"
      onSelectRow={onSelectStudent}
    />
  );
};

CourseStudentsTable.propTypes = {
  students: PropTypes.array,
  loading: PropTypes.bool,

  onFilterStudents: PropTypes.func,
  onRemoveStudent: PropTypes.func,
  onSelectStudent: PropTypes.func,
};

CourseStudentsTable.defaultProps = {
  students: [],
  loading: false,

  onFilterStudents: undefined,
  onRemoveStudent: undefined,
  onSelectStudent: undefined,
};

export default CourseStudentsTable;
